// extracted by mini-css-extract-plugin
module.exports = {"priceStrikethrough":"BaggageItem-module__priceStrikethrough___QN+4D","badges":"BaggageItem-module__badges___mL635"};